import React from 'react';
import { Icon, Label, Popup } from 'semantic-ui-react';
import type { ContractListDto } from '../../services/contracts/ContractService';
import {
  formatHandsetSummaryPopupText,
  mergeHandsetSummaries,
  type ContractListHandsetSummaryItem,
} from '../../utils/handsetSummary';

function collectHandsetItems(contract: ContractListDto & { groupContracts?: ContractListDto[] }): ContractListHandsetSummaryItem[] {
  if (contract.groupContracts?.length) {
    return mergeHandsetSummaries(
      contract.groupContracts.flatMap((c) =>
        (c.resumoAparelhos ?? []).map((r) => ({
          nome: r.nome,
          quantidade: r.quantidade,
          valorMensal: r.valorMensal,
          valorTotal: r.valorTotal,
        }))
      )
    );
  }
  return (contract.resumoAparelhos ?? []).map((r) => ({
    nome: r.nome,
    quantidade: r.quantidade,
    valorMensal: r.valorMensal,
    valorTotal: r.valorTotal,
  }));
}

export function contractHasHandsetCatalog(
  contract: ContractListDto & { groupContracts?: ContractListDto[] }
): boolean {
  if (contract.groupContracts?.length) {
    return contract.groupContracts.some((c) => c.temAparelhoCatalogo);
  }
  return !!contract.temAparelhoCatalogo;
}

export const ContractHandsetBadge: React.FC<{
  contract: ContractListDto & { groupContracts?: ContractListDto[] };
  interactive?: boolean;
}> = ({ contract, interactive = true }) => {
  if (!contractHasHandsetCatalog(contract)) return null;

  const items = collectHandsetItems(contract);
  const popupText = formatHandsetSummaryPopupText(items);

  return (
    <Popup
      content={<div style={{ whiteSpace: 'pre-line', maxWidth: 320 }}>{popupText}</div>}
      trigger={
        <Label
          size="tiny"
          style={{
            marginTop: '4px',
            cursor: interactive ? 'pointer' : 'default',
            background: 'linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%)',
            color: '#9d174d',
            border: '1px solid #f9a8d4',
            fontWeight: 700,
          }}
        >
          <Icon name="mobile alternate" />
          Aparelho
        </Label>
      }
      hoverable
      wide
    />
  );
};
